export default __webpack_public_path__ + "static/media/joint_mission_MONUSCO.7719fbb0.jpg";